import { HiOutlineInformationCircle } from 'react-icons/hi2';
import styles from './InfoTip.module.css';

interface InfoTipProps {
  text: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export function InfoTip({ text, position = 'top' }: InfoTipProps) {
  return (
    <span className={styles.wrapper}>
      <button
        type="button"
        className={styles.trigger}
        aria-label={text ? `Info: ${text.slice(0, 80)}` : 'Info'}
      >
        <HiOutlineInformationCircle />
      </button>
      <span className={`${styles.panel} ${styles[position]}`} role="tooltip">
        {text}
      </span>
    </span>
  );
}
